import RetailerService from '@/services/retailer/RetailerService.js'
import SalesChannelService from '@/services/retailer/SalesChannelService.js'

import { RETAILER_ERROR_MESSAGES } from '@/constants/errorMessages'

export const namespaced = true

export const state = {
  salesChannel: {},
  products: {},
  payment_methods: {}
}

export const mutations = {
  SET_PRODUCTS(state, params) {
    state.products[params.salesChannelId] = params.products
  },
  SET_SALES_CHANNEL(state, salesChannel) {
    state.salesChannel = salesChannel
  },
  SET_PAYMENT_METHODS(state, paymentMethods) {
    state.payment_methods = paymentMethods
  }
}

export const getters = {
  getSalesChannelConfigByKey: state => key => {
    let config = state.salesChannel.config ? state.salesChannel.config.find(config => config.key === key) : false

    return config ? true : false
  }
}

export const actions = {
  getSalesChannel({ commit, dispatch, state, rootState }, id) {
    if (id == state.salesChannel.id) {
      return state.salesChannel
    } else {
      return new Promise((resolve, reject) => {
        let auth = rootState.retailerAuth.user
        RetailerService.getSalesChannel(auth.retailer_id, id)
          .then(response => {
            commit('SET_SALES_CHANNEL', response.data)
            resolve(response.data)
          })
          .catch(err => {
            const notification = {
              type: 'danger',
              message: RETAILER_ERROR_MESSAGES.getSalesChannelsError
            }
            dispatch('notification/add', notification, {
              root: true
            })

            reject(err)
          })
      })
    }
  },
  getAllProducts({ commit, state }, salesChannelId) {
    if (salesChannelId == state.salesChannel.id && state.products[salesChannelId]) {
      return state.products[salesChannelId]
    } else {
      return new Promise(resolve => {
        SalesChannelService.getProducts(salesChannelId).then(response => {
          commit('SET_PRODUCTS', { salesChannelId, products: response.data })
          resolve(response.data)
        })
      })
    }
  },
  getPaymentMethods({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      SalesChannelService.getPaymentMethods(id)
        .then(response => {
          commit('SET_PAYMENT_METHODS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: RETAILER_ERROR_MESSAGES.getPaymentMethodsError
          }
          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  searchProduct({}, params) {
    return new Promise((resolve, reject) => {
      SalesChannelService.searchProduct(params.salesChannelId, params.query).then(response => {
        resolve(response.data)
      })
    })
  }
}
